import React, {useState} from 'react';
import {useTranslation} from 'next-i18next';
import styles from './style.module.css';
import Link from '@components/Common/Link';

const accordionData = [
  {
    key: 'accordion1',
    links: [
      {key: 'link1', url: 'url1'},
      {key: 'link2', url: 'url2'},
    ],
  },
  {
    key: 'accordion2',
    links: [
      {key: 'link3', url: 'url3'},
      {key: 'link4', url: 'url4'},
      {key: 'link5', url: 'url5'},
      {key: 'link6', url: 'url6'},
      {key: 'link7', url: 'url7'},
      {key: 'link8', url: 'url8'},
      {key: 'link9', url: 'url9'},
      {key: 'link10', url: 'url10'},
      {key: 'link11', url: 'url11'},
      {key: 'link12', url: 'url12'},
      {key: 'link13', url: 'url13'},
      {key: 'link14', url: 'url14'},
    ],
  },
  {
    key: 'accordion3',
    links: [
      {key: 'link15', url: 'url15'},
      {key: 'link16', url: 'url16'},
    ],
  },
  {
    key: 'accordion4',
    links: [
      {key: 'link17', url: 'url17'},
      {key: 'link18', url: 'url18'},
    ],
  },
  {
    key: 'accordion5',
    links: [
      {key: 'link19', url: 'url19'},
      {key: 'link20', url: 'url20'},
      {key: 'link21', url: 'url21'},
      {key: 'link22', url: 'url22'},
      {key: 'link23', url: 'url23'},
      {key: 'link24', url: 'url24'},
      {key: 'link25', url: 'url25'},
      {key: 'link26', url: 'url26'},
      {key: 'link27', url: 'url27'},
      {key: 'link28', url: 'url28'},
      {key: 'link29', url: 'url29'},
      {key: 'link30', url: 'url30'},
      {key: 'link31', url: 'url31'},
      {key: 'link32', url: 'url32'},
      {key: 'link33', url: 'url33'},
    ],
  },
  {
    key: 'accordion6',
    links: [{key: 'link28', url: 'url28'}],
  },
  {
    key: 'accordion7',
    links: [{key: 'link29', url: 'url29'}],
  },
  {
    key: 'accordion8',
    links: [
      {key: 'link30', url: 'url30'},
      {key: 'link31', url: 'url31'},
      {key: 'link32', url: 'url32'},
      {key: 'link33', url: 'url33'},
      {key: 'link34', url: 'url34'},
      {key: 'link35', url: 'url35'},
      {key: 'link36', url: 'url36'},
      {key: 'link37', url: 'url37'},
      {key: 'link38', url: 'url38'},
      {key: 'link39', url: 'url39'},
      {key: 'link40', url: 'url40'},
      {key: 'link41', url: 'url41'},
      {key: 'link42', url: 'url42'},
      {key: 'link43', url: 'url43'},
      {key: 'link44', url: 'url44'},
      {key: 'link45', url: 'url45'},
      {key: 'link46', url: 'url46'},
      {key: 'link47', url: 'url47'},
      {key: 'link48', url: 'url48'},
      {key: 'link49', url: 'url49'},
      {key: 'link50', url: 'url50'},
    ],
  },
];

const BIMObjects = () => {
  const [accordionStates, setAccordionStates] = useState(
    Array(accordionData.length).fill(false)
  );

  const toggleAccordion = (index: number) => {
    const newAccordionStates = [...accordionStates];
    newAccordionStates[index] = !newAccordionStates[index];
    setAccordionStates(newAccordionStates);
  };
  const {t} = useTranslation(['bim']);
  return (
    <div>
      <div className={styles.bimBanner}>
        <img
          src={
            'https://assets.liunedoor.com/upload/Liune Bim-objektit helpottavat suunnittelua.png'
          }
          alt="Logo"
        />
      </div>
      <div className={styles.accordionContainer}>
        <h1>{t<string>('title')}</h1>
        <p>{t<string>('text')}</p>
        <p>
          <strong>{t<string>('textb')}</strong>
        </p>
      </div>
      {accordionData.map((accordion, index) => (
        <div key={accordion.key} className={styles.accordionContainer}>
          <button
            className={`${styles.accordionButton} ${
              accordionStates[index] ? styles.open : ''
            }`}
            onClick={() => toggleAccordion(index)}
          >
            <>
              {t(accordion.key)}
              <span className={styles.accordionIcon}>
                {accordionStates[index] ? '-' : '+'}
              </span>
            </>
          </button>
          {accordionStates[index] && (
            <div className={styles.accordionLinks}>
              {accordion.links.map(link => (
                <Link key={link.key} href={t(link.url)}>
                  {t<string>(link.key)}
                </Link>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default BIMObjects;
